import { formatDate, formatStringDate } from '@domain/utils/format.utils';
import { GameType } from '@domain/game.selection/types/game.type';
import { GameInfo } from '@domain/game.selection/types/game.info';

import praiaLogo from '@assets/praia/praia-logo.png';
import PraiaStatsIcons from '@assets/praia/stat-icons';
import PraiaIFlags from '@assets/praia/data/iflags.json';

import rexLogo from '@assets/rex/rex-logo.png';
import RexStatsIcons from '@assets/rex/stat-icons';
import RexIFlags from '@assets/rex/data/iflags.json';

export const praiasAppData = ['CLASSIC', 'NEW'];
export const praiasAppWithBothData = [...praiasAppData, 'BOTH'];

export const gameInfos: GameInfo[] = [
  {
    type: GameType.Praia,
    title: 'Praia Bingo',
    useAppCode: true,
    urlId: 'praia',
    baseUrl: 'http://backoffice-praia.pipastudios.com/backoffice/v1',
    logoImgSrc: praiaLogo,
    statIcons: PraiaStatsIcons,
    iFlagsCatalog: PraiaIFlags,
    iFlagFormatter: (key, name, value) => {
      if (key === '97' || key === '101' || key === '1001') return formatStringDate(value);
      return value;
    },
  },
  {
    type: GameType.Rex,
    title: 'Bingo Rex',
    useAppCode: false,
    urlId: 'rex',
    baseUrl: 'http://backoffice-rex.pipastudios.com/backoffice/v1',
    logoImgSrc: rexLogo,
    statIcons: RexStatsIcons,
    iFlagsCatalog: RexIFlags,
    iFlagFormatter: (key, name, value) => {
      if (key === '103') return formatDate(new Date(parseInt(value, 10) * 1000));
      return value;
    },
  },
];

export function getGameInfoByUrlId(urlId: string) {
  return gameInfos.find((g) => g.urlId === urlId);
}
